import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { AthoraRoutingModule } from "./athora-routing.module";
import { AthoraComponent } from "./athora.component";
import { AdditionalPaymentComponent } from "./components/additional-payment/additional-payment.component";
import { AddressChangeComponent } from "./components/address-change/address-change.component";
import { BeneficiaryChangeComponent } from "./components/beneficiary-change/beneficiary-change.component";
import { BeneficiaryFormComponent } from "./components/beneficiary-form/beneficiary-form.component";
import { BranchSwitchDivestmentComponent } from "./components/branch-switch-divestment/branch-switch-divestment.component";
import { BranchSwitchInvestmentComponent } from "./components/branch-switch-investment/branch-switch-investment.component";
import { ClaimNotificationComponent } from "./components/claim-notification/claim-notification.component";
import { ContractorVariationComponent } from "./components/contractor-variation/contractor-variation.component";
import { PartialRedeemComponent } from "./components/partial-redeem/partial-redeem.component";
import { QuestionnaireModalComponent } from "./components/questionnaire-modal/questionnaire-modal.component";
import { QuestionnaireComponent } from "./components/questionnaire/questionnaire.component";
import { SingleStepBranchSwitchComponent } from "./components/single-step-branch-switch/single-step-branch-switch.component";
import { SubjectPfInsertFormComponent } from "./components/subject-pf-insert-form/subject-pf-insert-form.component";

@NgModule({
  declarations: [
    AdditionalPaymentComponent,
    BranchSwitchDivestmentComponent,
    BranchSwitchInvestmentComponent,
    PartialRedeemComponent,
    BeneficiaryChangeComponent,
    SingleStepBranchSwitchComponent,
    ContractorVariationComponent,
    AddressChangeComponent,
    BeneficiaryFormComponent,
    ClaimNotificationComponent,
    QuestionnaireComponent,
    QuestionnaireModalComponent,
    AthoraComponent,
    SubjectPfInsertFormComponent
  ],
  imports: [

    SharedModule,
    AthoraRoutingModule
  ]
})
export class AthoraModule { }
